
import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';




import { formatValueReais } from "../../../utils/ValidationUtils";

export default function HistoricoInfo({
  historicos,
  label,
  showHist
}: {
  historicos: any,
  label: string,
  showHist: boolean
}) {
  const { t } = useTranslation();

  const hasCartorio = historicos && historicos.some((h: any) => h.cartorio);
  const hasOrigem = historicos && historicos.some((h: any) => h.origem);
  const hasValor = historicos && historicos.some((h: any) => h.valor);
  const hasHistorico = historicos && historicos.some((h: any) => h.historico);

  return (
    <Panel header={(showHist ? t('historico') : '') + ' ' + label} style={{ width: '98%' }}>

      <DataTable size="small" value={historicos} breakpoint="960px" responsiveLayout="stack">
        {hasHistorico && <Column field="historico" header={label}></Column>}
        <Column field="data" header={t('data')}></Column>
        {hasCartorio && <Column field="cartorio" header={t('cartorio')}></Column>}
        {hasOrigem && <Column field="origem" header={t('origem')}></Column>}
        {hasValor && <Column field="valor" header={t('valor')} body={(rowData) => formatValueReais(rowData.valor)}></Column>}
      </DataTable>
    </Panel>
  )
}
